import type { KyInstance } from 'ky';

import { ensureError } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { MergePurgeParameters } from './types/merge-purge-parameters.type';
import type { MultisByList } from './types/multis-by-list.type';

/**
 * Retrieves a list of multis by list using the provided Ky HTTP client instance and search parameters.
 *
 * @param instance - The Ky HTTP client instance to use for the request.
 * @param searchParams - The parameters to filter the merge-purge multis by list.
 * @returns A promise that resolves to an {@link OperationResultWithData} containing an array
 * of {@link MultisByList}.
 * @throws Throws an error if the request fails.
 */
export const getMultisByList = async (instance: KyInstance, searchParams: MergePurgeParameters) => {
  try {
    return await instance
      .get<OperationResultWithData<MultisByList[]>>(Uri.reports.mergePurge.multisByList, {
        searchParams,
      })
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
